import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {IMaskInput} from 'react-imask'
import cn from 'classnames'
import {PaymentMethod} from '@raisenow/epik'
import {useStores} from '../../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../../lib/WidgetApi'
import {DynamicSlotName} from '../../../../../lib/DynamicSlotName'
import {ErrorMessage} from '../../../../ui/ErrorMessage'
import {DynamicSlot} from '../../../../dynamic/DynamicSlot'
import {PaymentForm} from '../../../../../lib/forms/PaymentForm'
import {SubscriptionRenewForm} from '../../../../../lib/forms/SubscriptionRenewForm'
import {InfoToggle} from '../../../../ui/InfoToggle'
import {IconMobile} from '../../../../ui/Icons'
import {InputWrapper} from '../../../../wrappers/InputWrapper'
import {DirtyWrapper} from '../../../../wrappers/DirtyWrapper'
import {
  countryCodeCH,
  getMsisdnMaskProps,
  omitCountryCode,
} from '../../../../../lib/helpers'

///////////////////////////////////////////////////////////////////////////////

export type SmsFormProps = {
  form: PaymentForm | SubscriptionRenewForm
}

///////////////////////////////////////////////////////////////////////////////

export const SmsForm: FC<SmsFormProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {form} = props
  const formData = form.data
  const errors = form.validationErrors
  const msisdn = omitCountryCode(formData.msisdn || '')
  const setMsisdn = (value: string) => (formData.msisdn = value)
  const infoToggleTitle = api.trans('info_toggle.sms.title', {
    defaultValue: null,
  })
  const infoToggleTextHTML = api.trans('info_toggle.sms.text_html', {
    defaultValue: null,
  })
  const msisdnMaskProps = getMsisdnMaskProps(setMsisdn)

  return (
    <div className={cn('payment-method-form', PaymentMethod.SMS)}>
      <DynamicSlot name={DynamicSlotName.SMS_FORM_START} form={form} />

      <div className="main">
        <div className="form-block msisdn">
          <div className="field-block">
            <label
              className="label-block"
              htmlFor={api.ui.generateUniqueElementId('msisdn')}
            >
              {api.trans('payment_form.msisdn')}
            </label>
            <InputWrapper form={form} fields="msisdn">
              <DirtyWrapper form={form} fields="msisdn">
                <IMaskInput
                  {...msisdnMaskProps}
                  type="tel"
                  id={api.ui.generateUniqueElementId('msisdn')}
                  aria-describedby={api.ui.generateUniqueElementId(
                    'msisdn-error',
                  )}
                  className="input-text"
                  name="msisdn"
                  placeholder={api.trans('payment_form.placeholders.msisdn')}
                  value={msisdn}
                  inputMode="tel"
                  autoComplete="tel-national"
                />
              </DirtyWrapper>
            </InputWrapper>

            <IconMobile />
            <span className="country-code">{countryCodeCH}</span>
          </div>

          <ErrorMessage
            errors={errors}
            errorKey="msisdn"
            id={api.ui.generateUniqueElementId('msisdn-error')}
          />
        </div>
      </div>

      <InfoToggle
        idKey="info-toggle-sms"
        className={cn('info-toggle-pm', 'info-toggle-sms')}
        title={infoToggleTitle}
        textHTML={infoToggleTextHTML}
      />

      <DynamicSlot name={DynamicSlotName.SMS_FORM_END} form={form} />
    </div>
  )
})
